import styled from "styled-components";

const StyledShopMobileMenu = styled.div`
  width: 100vw;
  height: 100%;
  top: 0;
  display: grid;
  grid-template-columns: 1fr minmax(100px, 360px);
  grid-template-rows: 50px 1fr;
  position: fixed;
  z-index: 4;
  transition: right .4s ease-in-out;
  right: -100vw;

  &[data-menu-state=true] {
    right: 0;

    .shop-mobile-menu__background {
      width: 100vw;
      height: 100vh;
      position: fixed;
      cursor: pointer;
      background: ${({theme}) => theme.colors.bundleWhite};
      left: 0;
      top: 0;
      z-index: 1;
      transition: background .4s ease-in-out;
    }
  }

  &[data-menu-state=false] {
    right: -100vw;
  }

  &.disabled__filters {
    .filter-product-price__radio,
    .filter-product-type__checkbox__copy{
      opacity: 0.5;
    }
  }

  .shop-mobile-menu__background {
    width: 100%;
    height: 100vh;
    position: absolute;
    cursor: pointer;
  }

  .shop-mobile-menu__nav {
    height: 100%;
    grid-column-start: 2;
    grid-row: 1 / 3;
    background-color: ${({theme}) => theme.colors.white};
    z-index: 2;
  }

  .shop-mobile-menu__nav__header {
    padding: 1rem 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${({theme}) => theme.colors.gray2};
  }

  .shop-mobile-menu__filter-heading {
    padding: 2.25rem 16px .375rem;
    color: ${({theme}) => theme.colors.brandDark};
  }

  .shop-mobile-menu__nav__heading {
    color: ${({theme}) => theme.colors.gray4};
  }

  .shop-mobile-menu__nav__clear {
    padding-right: 8px;
    padding-left: 8px;
    height: 32px;
    border-radius: 4px;
    color: ${({theme}) => theme.colors.brand};

    &:hover,
    &:focus {
      background-color: ${({theme}) => theme.colors.brand};
      color: ${({theme}) => theme.colors.white};
    }
  }

  .shop-mobile-menu__close {
    padding: 6px;
    display: flex;
    fill: ${({theme}) => theme.colors.black};
    border-radius: 4px;

    &:hover,
    &:focus {
      background-color: ${({theme}) => theme.colors.gray2};
    }

    svg {
      width: 20px;
      height: 20px;
      fill: inherit;
    }
  }

  .shop-mobile-menu__nav__filters {
    padding-bottom: 2.25rem;
    position: relative;
    height: calc(100% - 146px);
    overflow: auto;
  }

  .filter_loading {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: ${({theme}) => theme.colors.whiteTransparent};
    z-index: 5;

    .placeholder__loading {
      text-align: center;
      align-items: center;
    }
  }

  .shop-mobile-menu__nav__wrapping-types {
    padding: 14px 28px 0;
  }

  .shop-mobile-menu__nav__show-results {
    padding: 16px;
    width: 100%;
    bottom: 0;
    left: 0;
    background-color: ${({theme}) => theme.colors.gray1};
  }

  .shop-mobile-menu__search-button {
    padding: 14px 16px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({theme}) => theme.colors.gray2};

    &:hover,
    &:focus {
      border-color: ${({theme}) => theme.colors.brand};
      box-shadow: inset 0 -2px 0  ${({theme}) => theme.colors.brand};

      svg {
        fill: ${({theme}) => theme.colors.brand};
      }
    }
  }

  .shop-mobile-menu__search-button__copy {
    margin-right: 8px;
    display: flex;
    flex-direction: column;

    span:first-child {
      margin-bottom: .25rem;
      color: ${({theme}) => theme.colors.gray4};
    }
    span:not(:first-child) {
      color: ${({theme}) => theme.colors.gray3};
    }
  }

  .shop-mobile-menu__search-button__icon {
    height: 14px;
    width: 10px;
    fill: ${({theme}) => theme.colors.gray3};
  }
`;
export default StyledShopMobileMenu;